<template>
  <div class="container-message-manager">
    <div class="message-text-box">
      <!-- i18n -->
      <div
        ref="userInput"
        class="message-input"
        :placeholder="$t('messages.typeAMessagePlaceholder')"
        tabIndex="0"
        contenteditable="true"
        @keydown="handleInput"
        ></div>
    </div>
    <div>
      <PolygonLoader v-if="sendingMessage" class="mr-2" :size="20" :width="2" :centered="false"/>
      <v-btn
        icon
        text
        color="primary"
        @click="sendMessage"
      >
        <v-icon>mdi-send</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import messageRepository from '@/core/repository/message-repository'
import toasts from '@/core/toasts'
import _ from 'lodash'
export default {
  props: {
    mentionMode: {
      type: Boolean,
      required: true
    },
    mentions: {
      type: Array,
      required: true
    },
    selectedMentionIndex: {
      type: Number,
      required: true
    }
  },
  data() {
    return{
      sendingMessage: false
    }
  },
  methods: {
    handleInput(e) {
      if (this.mentionMode) {
        this.handleInputMentionMode(e)
      } else {
        if (e.key === '@') {
          this.publish('goToMentionMode')
        }
        if (e.key === 'Enter') {
          e.preventDefault()
          this.sendMessage()
        }
      }
    },
    handleInputMentionMode(e) {
      switch (e.key) {
        case 'ArrowUp':
          this.publish('changeSelectedMentionIndex', -1)
          break
        case 'ArrowDown':
          this.publish('changeSelectedMentionIndex', 1)
          break
        case 'Escape':
          this.publish('jumpOutMentionMode')
          break
        case 'Enter':
          e.preventDefault()
          this.publish('selectedMention', this.errandMembers.chatMentionParticipants[this.selectedMentionIndex])
          break
        default:
          this.publish('jumpOutMentionMode')
          break
      }
    },
    sendMessage(e) {
      const message = this.$refs.userInput.textContent.trim()
      const mentions = this.extractMentions(message)
      if(message) {
        this.sendingMessage = true
        messageRepository.postMessage(this.errandId, { message: message, mentions: mentions })
          .done(() => {
            this.publish('messageSent')
            this.$refs.userInput.textContent = ''
          })
          .fail(() => {
            // i18n
            toasts.error('Kunde inte skicka meddelandet')
          })
          .always(() => {
            this.sendingMessage = false
          })
      }
    },
    extractMentions(message) {
      const mentions = _.chain(this.mentions).filter(item => message.includes(item)).uniq().value()
      return _.join(mentions, ';')
    }
  }
}
</script>

<style lang="scss" scoped>
.quick-chat-container .container-message-manager {
  height: 65px;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 20px 0 20px;
  -webkit-box-shadow: 0px -1px 20px 0px rgba(var(--color-subtle),1);
  box-shadow: 0px -1px 20px 0px rgba(var(--color-subtle), 1);
  // box-shadow: none;
  // webkit-box-shadow: none;

  .message-text-box {
    padding: 0 10px 0 10px;
    flex: 1;
    overflow: hidden;
  }

  .message-input {
    width: 100%;
    resize: none;
    border: none;
    outline: none;
    box-sizing: border-box;
    font-size: 15px;
    font-weight: 400;
    line-height: 1.33;
    white-space: pre-wrap;
    word-wrap: break-word;
    color: #565867;
    -webkit-font-smoothing: antialiased;
    max-height: 40px;
    bottom: 0;
    overflow: scroll;
    overflow-x: hidden;
    overflow-y: auto;
    text-align: left;
    cursor: text;
    display: inline-block;
  }

  .message-input:empty:before {
    content: attr(placeholder);
    display: block; /* For Firefox */
    filter: contrast(15%);
    outline: none;
  }

  .message-input:focus {
    outline: none;
  }
}
</style>
